import React from 'react';

const notAvailableWidth = 40;
const oofBoxWidth = 250;
const rectXOffset = 15;
const rectYOffset = 40;
const textYOffset = 2;
const xFactorOffset = 6;
const angle = 0.25;

function Shape({ shape, w, h, x, y, r, coords, ...props }) {
	if(shape === 'rect') {
		return <rect {...props} width={w} height={h} x={x} y={y} />;
	} else if(shape === 'circle') {
		return <circle {...props} cx={x} cy={y} r={r} />;
	} else if(shape === 'poly') {
		return <polygon {...props} coords={coords.join(' ')} />;
	}
	return null;
}

function getTopRight({ shape, ...props }) {
	if(shape === 'rect') {
		const { x, y, w } = props;
		return { x: x + w, y };
	} else if(shape === 'circle') {
		const { x, y, r } = props;
		return {
			x: x + Math.cos(Math.PI * angle) * r,
			y: y + Math.sin(Math.PI * angle) * r
		};
	} else if(shape === 'poly') {
		let maxX = -Infinity;
		let maxY = -Infinity;
		for(const [x, y] of props.coords) {
			maxX = Math.max(x, maxX);
			maxY = Math.max(y, maxY);
		}
		return { x: maxX, y: maxY };
	}
	return null;
}

function NotAvailable(props) {
	const pos = getTopRight(props);
	if(!pos) {
		return null;
	}
	const { x, y } = pos;
	return <g className="pe-none">
		<Shape {...props} fill="#fff" opacity="0.5" />
		<rect
			x={x - notAvailableWidth * xFactorOffset - rectXOffset}
			y={y - rectYOffset}
			width={oofBoxWidth}
			rx="20" ry="20"
			height={60}
			opacity='0.6'
			fill="#e8c56a"
		/>
		<text
			fontSize={notAvailableWidth}
			fill='black'
			x={x - notAvailableWidth * xFactorOffset}
			y={y + textYOffset}>
			Out of stock
		</text>
	</g>;
}

function Mapping({ mapping, onClick, available}) {
	return <>
		{!available && <NotAvailable {...mapping} />}
		<a onClick={onClick} href="#">
			<Shape {...mapping} opacity="0" />
		</a>
	</>;
}

export default function SvgPage({ width, height, src, mappings, onMappingClick, pageSkus }) {
	if(!src) {
		return null;
	}
	return <div className="svgHolder">
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} height={height} preserveAspectRatio="xMinYMin meet">
			<image width={width} height={height} xlinkHref={src} />
			{mappings.map((mapping, i) => {
				return <Mapping key={i} mapping={mapping} available={pageSkus && pageSkus[mapping.item] ? pageSkus[mapping.item].availability > 0 : true} onClick={() => onMappingClick(mapping.item)} />;
			})}
		</svg>
	</div>;
}
